import { h } from "preact";

export function Loading() {
  return (
    <div class="Loading">
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}
